import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import { Button } from "reactstrap";
import { Helmet } from "react-helmet";
import Spinner from "../../Spinner/spinner";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { localeEs } from "../../locale/ag-grid-es";
import withTokenCheck from "../../withTokenCheck";

const AppReasignacionHogar = ({ token }) => {
    const [infoBitacora, setInfoBitacora] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalRows, setTotalRows] = useState(0); // total de registros en BD
    const [currentPage, setCurrentPage] = useState(1);
    const gridApi = useRef(null);
    const [lastPage, setLastPage]         = useState(1);
    const [perPage, setPerPage]           = useState(20);

    const fetchPage = useCallback((page, perPage) => {
        axios.get("/bitacora", {
            headers: { Authorization: `Bearer ${token}` },
            params: { page, per_page: perPage }, // 👈 le manda la página al back
        })
            .then((response) => {
                setInfoBitacora(response.data.data);   // 👈 ahora es .data.data
                setTotalRows(response.data.total);
                setLastPage(response.data.last_page);
                setCurrentPage(response.data.current_page);
                setLoading(false);
            }).catch((error) => {
                console.error(error);
            })
            .finally(() => {
                setLoading(false); // ✅ siempre quita el spinner
            });
    }, [token]);

    useEffect(() => {
        fetchPage(1, 20);
    }, [fetchPage]);


    const defaultColDef = {
        sortable: true,
        resizable: true,
        filter: true,
        editable: true,
    };

    const columnDefs = [
        {
            field: "formulario.NumeroCaso",
            headerName: "Numero de Caso",
        },
        {
            field: "Accion",
            headerName: "Accion",
        },
        {
            field: "Observacion",
            headerName: "Observación",
        },
        {
            field: "Fecha",
            headerName: "Fecha Acción",
        },
        {
            field: "usuario.name",
            headerName: "Usuario que modifico",
        },
    ];

    const goToPage = (page) => {
        if (page < 1 || page > lastPage) return;
        fetchPage(page, perPage);
    };

    // Cambiar tamaño de página
    const handlePerPageChange = (e) => {
        const newSize = Number(e.target.value);
        setPerPage(newSize);
        fetchPage(1, newSize);
    };

    const onGridReady = (params) => {
        gridApi.current = params.api;
    };

    const handleExportCSV = () => {
        gridApi.current.exportDataAsCsv();
    };



    return (
        <>
            <Helmet>
                <title>Bitacora</title>
            </Helmet>
            {loading ? (
                <Spinner />
            ) : (
                <div className="container-fluid mt-5">
                    <Button color="success" onClick={handleExportCSV}>
                        Exportar CSV (Excel)
                    </Button>
                    <div
                        className="mt-3"
                        style={{ height: "500px", width: "100%" }}
                    >
                        <div
                            className="ag-theme-alpine"
                            style={{ height: "100%", width: "100%" }}
                        >
                            <AgGridReact
                                rowData={infoBitacora}
                                columnDefs={columnDefs}
                                defaultColDef={defaultColDef}
                                onGridReady={onGridReady}
                                localeText={localeEs}
                                pagination={false}
                            />
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between mt-2">

                        {/* Info y selector de tamaño */}
                        <div className="d-flex align-items-center gap-2">
                            <small className="text-muted">
                                Mostrando {((currentPage - 1) * perPage) + 1}–{Math.min(currentPage * perPage, totalRows)} de {totalRows} registros
                            </small>
                            <select
                                className="form-select form-select-sm ms-3"
                                style={{ width: "auto" }}
                                value={perPage}
                                onChange={handlePerPageChange}
                            >
                                <option value={20}>20 por página</option>
                                <option value={50}>50 por página</option>
                                <option value={100}>100 por página</option>
                            </select>
                        </div>

                        {/* Botones de navegación */}
                        <div className="d-flex align-items-center gap-1">
                            <button
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => goToPage(1)}
                                disabled={currentPage === 1}
                            >«</button>
                            <button
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => goToPage(currentPage - 1)}
                                disabled={currentPage === 1}
                            >‹</button>

                            <span className="mx-2 small">
                                Página {currentPage} de {lastPage}
                            </span>

                            <button
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => goToPage(currentPage + 1)}
                                disabled={currentPage === lastPage}
                            >›</button>
                            <button
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => goToPage(lastPage)}
                                disabled={currentPage === lastPage}
                            >»</button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default withTokenCheck(AppReasignacionHogar);
